export default class InsuranceInfo {
  isInsured: boolean = false;
  amount: number = 0;

  public constructor(init?: Partial<InsuranceInfo>) {
    Object.assign(this, init);
  }
}
